// «Анна остановлена» для чтения с экрана (задача D15): остановку объявляет пилюля статуса в `aria-live="assertive"` (D5).
// Она замечает переход статуса в «Остановлена» — но статус приходит запросом позже, а у Sonner область тостов одна и
// `polite`. Поэтому остановка из этого окна («Остановить» в «Запуске», «Остановить везде» в пилюле) отмечается здесь
// сразу после ответа сервера, и пилюля объявляет её тем же текстом в той же области — один раз: когда следом придёт
// статус «Остановлена», текст области не изменится и второго объявления не будет.
import { useSyncExternalStore } from 'react';

let stops = 0;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function snapshot(): number {
  return stops;
}

/** Анну только что остановили из этого окна. */
export function noteStoppedHere(): void {
  stops += 1;
  for (const listener of listeners) listener();
}

/** Сколько раз за жизнь вкладки Анну останавливали из этого окна: растёт — пора объявить. */
export function useStoppedHereCount(): number {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
